import axios from 'axios';
import { Platform } from 'react-native';
import { NotificationItem } from './types';

export function preferenceIsPushNotification(item: NotificationItem) {
  if (item.key === 'APN' || item.key === 'FCM') {
    return true;
  }

  return false;
}

export function formatPreferences(preferences: NotificationItem[], hasPushPermissions?: boolean) {
  const withPushNormalization = preferences.map(item => ({
    ...item,
    enabled: preferenceIsPushNotification(item) && !hasPushPermissions ? false : item.enabled
  }));

  if (Platform.OS === 'ios') {
    return withPushNormalization.filter(item => item.key !== 'FCM');
  }

  return withPushNormalization.filter(item => item.key !== 'APN');
}

export const checkPushPermission = async () => {
  if (Platform.OS === 'ios') {
    // const res = await Permissions.check('notification');
    // return res === 'authorized';
  }

  // return firebase.messaging().hasPermission();
};

export const requestPermission = async () => {
  return false;
};

export const withPushPermissions = async (callback: (hasPushPermissions: boolean) => void) => {
  try {
    const status = await checkPushPermission();

    // if (status) {
    //   return callback(status);
    // }

    const requestCheck = await requestPermission();

    return callback(requestCheck);
  } catch (err) {
    return callback(false);
  }
};
